import businessProducts from '../utils/products';
import consumerProducts from '../utils/consumerProducts';

const translations = {
	'moi.consumer.CustomerServicePage.header': 'Moin Asiakaspalvelu',
	'moi.business.CustomerServicePage.header': 'Moin Yritysasiakaspalvelu',

	'moi.consumer.SimsPage.header': 'Simmit',
	'moi.business.SimsPage.header': 'Liittymät',
	'moi.consumer.SimsPage.singleSim': 'simmi',
	'moi.business.SimsPage.singleSim': 'liittymä',
	'moi.consumer.SimsPage.severalSims': 'simmiä',
	'moi.business.SimsPage.severalSims': 'liittymää',

	'moi.consumer.SimSettings.services': 'Lisäpalvelut',
	'moi.business.SimSettings.services': 'Palvelut',
	'moi.consumer.SimSettings.voiceMail': 'Vastaaja +' + consumerProducts.getSimVoiceMailPrice().toFixed(2) + ' €/kk',
	'moi.business.SimSettings.voiceMail': 'Vastaaja (+' + businessProducts.getSimVoiceMailPrice() + ' €, alv 0%)',

	'moi.consumer.ServiceExpenses.header': 'Lisämaksulliset palvelut',
	'moi.business.ServiceExpenses.header': 'Kertyneet palvelumaksut',
	'moi.consumer.Menu.dashboard': 'Tili',
	'moi.business.Menu.dashboard': 'Kulutus',
	'moi.consumer.Menu.sims': 'Simmit',
	'moi.business.Menu.sims': 'Liittymät',
	'moi.consumer.Menu.invoices': 'Laskutus',
	'moi.business.Menu.invoices': 'Laskut',
	'moi.consumer.Menu.customerInfo': 'Omat tiedot',
	'moi.business.Menu.customerInfo': 'Asiakastiedot',
	'moi.business.Menu.order': 'Muokkaa tilausta',
	'moi.business.Menu.activateSubscription': 'Ota käyttöön liittymä',
	'moi.consumer.Menu.subscriptionsOrder': 'Tilaa lisää simmejä',
	'moi.business.Menu.orderMore': 'Tilaa lisää simmejä',
	'moi.consumer.Menu.customer-service': 'Asiakaspalvelu',
	'moi.business.Menu.customer-service': 'Asiakaspalvelu',
	'moi.consumer.Menu.logout': 'Kirjaudu ulos',
	'moi.business.Menu.logout': 'Kirjaudu ulos',
	'moi.consumer.Menu.offeringChange': 'Päivitä liittymät',
	'moi.consumer.Dashboard.title': 'Tili',
	'moi.business.Dashboard.title': 'Kulutus',

	'moi.consumer.CustomerServicePage.link': 'https://asiakaspalvelu.moi.fi/',
	'moi.business.CustomerServicePage.link': 'https://www.moi.fi/yrityksille/asiakaspalvelu/',
	'moi.consumer.CustomerServicePage.phone': '044 770 6000',
	'moi.business.CustomerServicePage.phone': '030 1500 559',
	'moi.consumer.CustomerServicePage.email': 'asiakaspalvelu@moi.fi',
	'moi.business.CustomerServicePage.email': 'yritysaspa@moi.fi'
};

export const getFromTranslations = (id) => translations[id];
